type SectionHeaderProps = {
  title: string
  onViewAll: () => void
  actionLabel?: string
  hideAction?: boolean
}

const SectionHeader = ({ title, onViewAll, actionLabel = 'View all', hideAction = false }: SectionHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <p className="text-[15px] font-semibold text-primary">{title}</p>
      {!hideAction && (
        <button className="text-[13px] text-muted underline" onClick={onViewAll}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}

export default SectionHeader
